const inrFormatter = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatInr = (value) => {
  if (value === null || value === undefined || typeof value === 'boolean' || (typeof value === 'string' && !value.trim()) || !['number', 'string'].includes(typeof value)) return null;
  const amount = Number(value);
  return Number.isFinite(amount) && amount >= 0 ? inrFormatter.format(amount) : null;
};

export const MONEY_CLASSNAME = 'font-sans tabular-nums tracking-normal leading-normal normal-case';